import request from '@/utils/request'
//获取首页聚合数据
export function getHomeData() {
    return request({
        url: '/admin-api/teach/home/data',
        method: 'get'
    })
}

//获取轮播图
export function getbanner(data) {
    return request({
        url: '/admin-api/teach/banner/page',
        method: 'get',
        params:data
    })
}

//获取课程类型列表
export function getcoursetype(data) {
    return request({
        url: '/admin-api/course/type/list',
        method: 'get',
        params:data
    })
}

 //获取课程列表
export function courseinfo(data) {
    return request({ 
      method: 'get',
      url: '/admin-api/course/info/page',
      params:data
    })
  }
  //获取课程详情
  export function getcourse(data) {
    return request({
        url: '/admin-api/course/info/get',
        method: 'get',
        params:data
    }) 
  }

  

  //获取讲师
export function getteachers(data) {
    return request({
        url: '/admin-api/teach/teachers/page',
        method: 'get',
        params:data
    })  
}

//获取单个讲师详情
export function getteacher(data) {
    return request({
        url: '/admin-api/teach/teachers/get',
        method: 'get',
        params:data
    })  
}

  //获取作品列表
  export function getworks(data) {
    return request({
        url: '/admin-api/teach/works/page',
        method: 'get',
        params:data
    })  
}
export function getwork(data) {
    return request({
        url: '/admin-api/teach/works/get',
        method: 'get',
        params:data
    })  
}

//获取新闻
export function getnews(data) {
    return request({
        url: '/admin-api/teach/news/page',
        method: 'get',
        params:data
    })
}

//获取新闻详情
export function getnewsdetail(data) {
    return request({
        url: '/admin-api/teach/news/get',
        method: 'get',
        params:data
    })
}

//用户登录
export function login(data) {
    return request({
        url: '/admin-api/system/auth/login',
        method: 'post',
        data:data
    })
}

//刷新token
export function refreshToken(refreshToken) {
    return request({
        url: '/admin-api/system/auth/refresh-token',
        method: 'post',
        params: {
            refreshToken: refreshToken
        }
    })
}

//教师/学生登录
export function teachStudentLogin(data) {
    return request({
        url: '/admin-api/system/auth/student-login',
        method: 'post',
        data:data
    })
}

//用户登出
export function logout() {
    return request({
        url: '/admin-api/system/auth/logout',
        method: 'post'
    })
}

//获取用户信息
export function getUserProfile() {
    return request({
        url: '/admin-api/system/user/profile/get',
        method: 'get'
    })
}

// 新增：修改用户个人资料（姓名、性别、电话、邮箱）
export function updateUserProfile(data) {
    return request({
        url: '/admin-api/system/user/profile/update',
        method: 'put',
        data: data
    })
}

//修改用户密码
export function updateUserPassword(data) {
    return request({
        url: '/admin-api/system/user/profile/update-password',
        method: 'put',
        data: data
    })
}

//更新用户头像
export function updateUserAvatar(file) {
    const formData = new FormData()
    formData.append('avatarFile', file)
    return request({
        url: '/admin-api/system/user/profile/update-avatar',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

//获取我的班级分页列表
export function getMyClasses(data) {
    return request({
        url: '/admin-api/teach/personal/my-classes',
        method: 'get',
        params: data
    })
}

//根据班级ID获取视频列表
export function getClassVideos(classIds) {
    return request({
        url: '/admin-api/teach/personal/class-videos',
        method: 'get',
        params: {
            classIds: classIds.join(',')
        }
    })
}






//获取公开课列表
export function getPublicCourses(data) {
    return request({
        url: '/admin-api/teach/personal/public-courses',
        method: 'get',
        params: data
    })
}



//获取视频详情信息
export function getVideoPlayerInfo(videoId) {
    return request({
        url: '/admin-api/teach/personal/player-info',
        method: 'get',
        params: {
            videoId: videoId
        }
    })
}


// 直播
export function getWatchUrl(data) {
    return request({
        url: '/admin-api/teach/personal/watch-url',
        method: 'get',
        params:data

    })
}